var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "page-loading-wrap",
      style: {
        position: _vm.isGlobal ? "fixed" : "absolute"
      }
    },
    [_c("div", { staticClass: "loading-bg" }), _vm._v(" "), _vm._m(0)]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-loading-spinner" }, [
      _c("img", {
        staticClass: "loader-icon",
        attrs: { src: require("../../assets/images/loading.png") }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }